<template>
  <ul class="navbar-nav ml-2">
    <li class="nav-item">
      <b-dropdown @shown="onShown">
        <template slot="button-content">
          <i class="icon-earth mr-2" />
          {{ currentLocale ? currentLocale.native : $t('general.loading') }}
        </template>
        <b-dropdown-item
          v-for="locale in locales"
          :key="locale.locale"
          @click="setLocale(locale.locale)"
        >
          {{ locale.name }} ({{ locale.native }})
        </b-dropdown-item>
      </b-dropdown>
    </li>
  </ul>
</template>

<script>
import { find } from 'lodash-es'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'LanguageSwitcher',
  data() {
    return {}
  },

  computed: {
    ...mapState('languageSwitcher', ['locales']),
    currentLocale() {
      return find(this.locales, { locale: this.$i18n.locale })
    },
  },

  mounted() {
    if (this.locales.length) {
      return
    }

    this.$http.get('translations/locales').then(response => {
      this.setLocales(response.data)
    })
  },

  methods: {
    // Removing scroll effect after dropdown shown
    onShown() {
      window.scrollTo(0, 0)
    },
    setLocale(locale) {
      this.$root.setLocale(locale)
    },
    ...mapMutations('languageSwitcher', ['setLocales']),
  },
}
</script>
